import { REGION_CONFIG } from '@/config/regions'

export const statuses = [
  {
    id: 1,
    slug: 'active',
    name: 'Действующий',
    text: 'Показать активные объекты',
    checked: true,
    show: true,
  },
  {
    id: 2,
    slug: 'inactive',
    name: 'Не действующий',
    text: 'Показать не действующие объекты',
    checked: true,
    show: true,
  },
  {
    id: 3,
    slug: 'planned',
    name: 'Планируемый',
    text: 'Показать планируемые объекты',
    checked: true,
    show: true,
  },
  {
    id: 7,
    slug: 'reconstruction',
    name: 'Реконструкция',
    text: 'Показать реконструкционные объекты',
    checked: true,
    show: REGION_CONFIG.hasReconstructionStatus,
  },
  {
    id: 8,
    slug: 'terminatingUsage',
    name: 'Выведение из эксплуатации',
    text: 'Показать выведенные из эксплуатации объекты',
    checked: true,
    show: REGION_CONFIG.hasTerminatingUsageStatus,
  },
  {
    id: 9,
    slug: 'renewUsage',
    name: 'Вновь вводимый',
    text: 'Показать вновь вводимые объекты',
    checked: true,
    show: REGION_CONFIG.hasRenewUsageStatus,
  },
]
